import "./ReportData.css";
import axios from "axios";
import { useEffect, useState } from "react";

import loadingImage from "../../assets/images/loading.gif";

import Title from "../../components/title/Title";
import { useParams } from "react-router-dom";

const ReportData = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [title, setTitle] = useState("");
  const { id } = useParams();

  useEffect(() => {
    getReport();
    setTitle(sessionStorage.getItem("reportName"));
  }, []);

  const getReport = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/actions/reports/${id}`, {
        headers: { Authorization: localStorage.getItem("token") },
      });
      setTimeout(() => {
        setLoading(false);
        setData(response.data);
      }, 1000);
    } catch (error) {
      setLoading(false);
    }
  };

  let headers;
  if (data && data.length > 0) {
    console.log(Object.keys(data[0]));
    headers = Object.keys(data[0]);
  }

  return (
    <div id="report">
      <Title text={title} displayBackButton={true} />
      {loading ? (
        <img id="loading" src={loadingImage} alt="" />
      ) : (
        <div id="data">
          {headers ? (
            <table>
              <thead>
                <tr>
                  {headers.map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((row, index) => {
                  return (
                    <tr key={index}>
                      {headers.map((header) => (
                        <td key={header}>
                          {typeof row[header] == "boolean"
                            ? row[header]
                              ? "V"
                              : "X"
                            : row[header]}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <h3>אין מידע לתצוגה</h3>
          )}
        </div>
      )}
    </div>
  );
};

export default ReportData;
